class TenantAddress {
  getHtml(data, questionDiv) {
    const text = questionDiv.querySelector('[data-binding="text"]');

    text.value = 'What is the address of the place you are renting with us?';
    const wrapper = document.createElement('span');
    wrapper.classList.add('system_question');
    text.before(wrapper);
    wrapper.append(text);
    text.insertAdjacentHTML('afterend', '<br><small>Prospects can answer by selecting one of your listings (both on and off market).</small>');

    return questionDiv;
  }

  bindEvents() {}

  init(wrapper) {
    this.bindEvents(wrapper);
  }

  isSingleQuestion() {
    return true;
  }
}

window.TenantAddress = TenantAddress;
